<form-control-container #container [control]="controlInstance">
  <div label-extension>
    <ng-content select="[label-extension]"></ng-content>
  </div>

  <ng-container *ngIf="!showReadonlyValue">
    <div class="btn-group">
      <button *ngFor="let option of options"
              type="button"
              [disabled]="disabled"
              class="btn btn-sm btn-default"
              [class.activated]="option.value == value"
              (click)="value = option.value">
        {{option.displayName}}
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="showReadonlyValue">
    <span class="readonly-value" [innerHTML]="selectedOption?.displayName"></span>
  </ng-container>
</form-control-container>
